import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = new EncryptStorage(process.env.VUE_APP_ENCRYPT_STORAGE_KEY);
